module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/sepa-direct-debit-en-b7efd6b348b3eea3a465db08482a953e.svg";